export default __webpack_public_path__ + "media/images/house-image-2-67e8212d2aa21aa7a1771999ea654238.png";